
import Vue from 'vue';
import EuCard from '../Card/Card.vue';
import NewEmailIcon from '../../../Icons/NewEmailIcon.vue';
import NewChatIcon from '../../../Icons/NewChatIcon.vue';
import NewPhoneIcon from '../../../Icons/NewPhoneIcon.vue';
import NewWhatsappIcon from '../../../Icons/NewWhatsappIcon.vue';
/**
- View for Contact list. The menu list is customizable, simply pass props <b>contactOptions</b> with each icon, id and title. Has 2 types:
- Dropdown: Dropdown menu with backdrop when open (default)
- Grid: Simple grid style contacts
 **/
export default Vue.extend<any, any, any, any>({
  name: 'Contacts',
  data() {
    return {
      opened: false
    };
  },
  components: {
    NewEmailIcon,
    NewPhoneIcon,
    NewWhatsappIcon,
    NewChatIcon,
    EuCard
  },
  props: {
    /**
     * Set id
     */
    id: {
      type: [Number, String],
      default: ''
    },
    /**
     * Set card elevation type (sort by thickness: thin, interactive, float, thicker)
     */
    elevation: {
      type: String,
      default: 'thicker'
    },
    /**
     * Set icon
     */
    askIcon: {
      type: String,
      default: 'https://img.qoala.app/qapp-assets/core/BabyQoala.png'
    },
    /**
     * Set sublabel
     */
    sublabel: {
      type: String,
      default: 'Questions?'
    },
    /**
     * Set title label
     */
    title: {
      type: String,
      default: 'Ask Us'
    },
    /**
     * Set contact type (grid / dropdown)
     */
    gridView: {
      type: Boolean,
      default: false
    },
    /**
     * Contact options (note: icon can be object svg / string url)
     */
    contactOptions: {
      type: Array,
      default: () => [
        {
          id: 'chat',
          icon: NewChatIcon,
          title: 'Chat',
          subtitle: 'Fastest response'
        },
        {
          id: 'whatsapp',
          icon: NewWhatsappIcon,
          title: 'Whatsapp',
          subtitle: '24/7'
        },
        {
          id: 'email',
          icon: NewEmailIcon,
          title: 'Email',
          subtitle: 'Fastest response'
        },
        {
          id: 'call',
          icon: NewPhoneIcon,
          title: 'Call',
          subtitle: 'Now Online!'
        }
      ]
    },
    /**
     * Set icon height
     */
    iconHeight: {
      type: String,
      default: '16'
    },
    /**
     * Set icon width
     */
    iconWidth: {
      type: String,
      default: '16'
    }
  },
  methods: {
    handleExpand() {
      this.opened = !this.opened;
      /**
       * Click to show the dropdown
       * @event expand
       * @type {function}
       */
      this.$emit('expand');
    },
    handleContact(index: any) {
      this.opened = false;
      /**
       * Handle when user click a menu list
       * @event click
       * @type {function}
       */
      this.$emit('click', index);
    }
  }
});
